"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Typography_1 = __importDefault(require("../Typography"));
exports.Checkbox = react_1.forwardRef((_a, ref) => {
    var { id, className, label, textClassName, isInline = true, disabled, alignItems = 'start' } = _a, restProps = __rest(_a, ["id", "className", "label", "textClassName", "isInline", "disabled", "alignItems"]);
    const checkboxBaseClassName = 'bds-c-checkbox';
    const checkboxIsInlineClassName = isInline
        ? `${checkboxBaseClassName}--inline`
        : `${checkboxBaseClassName}--block`;
    const checkboxAlignItemsClassName = alignItems
        ? `${checkboxBaseClassName}--align-items-${alignItems}`
        : '';
    const checkboxIsDisabledClassName = disabled ? 'bds-is-disabled' : '';
    const checkboxClassName = classnames_1.default(checkboxBaseClassName, checkboxIsDisabledClassName, checkboxIsInlineClassName, checkboxAlignItemsClassName, className);
    const checkboxTextClassName = classnames_1.default(`${checkboxBaseClassName}__text`, textClassName);
    return (react_1.default.createElement("label", { className: checkboxClassName, id: `${id}-label` },
        react_1.default.createElement("input", Object.assign({ id: id, className: `${checkboxBaseClassName}__input`, type: 'checkbox', ref: ref, disabled: disabled }, restProps)),
        react_1.default.createElement("span", { className: `${checkboxBaseClassName}__icon` },
            react_1.default.createElement("span", { className: `${checkboxBaseClassName}__icon-checked` },
                react_1.default.createElement("svg", { className: `${checkboxBaseClassName}__icon-checked-icon`, fill: 'white', width: '10', height: '8', viewBox: '0 0 10 8', xmlns: 'http://www.w3.org/2000/svg' },
                    react_1.default.createElement("path", { d: 'M8.72365 0.501836C9.01563 0.208942 9.48904 0.208942 9.78103 0.501836C10.0464 0.7681 10.0706 1.18477 9.8534 1.47838L9.78103 1.5625L3.64486 7.71783L0.218985 4.28125C-0.0729951 3.98835 -0.0729951 3.51348 0.218985 3.22059C0.484423 2.95432 0.899787 2.93011 1.19248 3.14797L1.27634 3.22059L3.64473 5.59579L8.72365 0.501836Z' }))),
            react_1.default.createElement("span", { className: `${checkboxBaseClassName}__icon-unchecked` })),
        react_1.default.createElement(Typography_1.default, { className: checkboxTextClassName, as: 'span', type: 'label-md' }, label)));
});
exports.Checkbox.displayName = 'Checkbox';
exports.default = exports.Checkbox;
